import { RootState } from '../redux/types';

export const selectFeatures = (state: RootState): Record<string, boolean> => {
  return state.features;
};
